import React from "react";
import { connect } from "react-redux";
import { changeEtapas, getListadoPlanesMovilidad } from "../actions";
import { getDocumentoEstadisticas, scrollElementToTop, dataLayerTag } from "../functions";
import IMG_LOADING from "../../../../images/animacion2[18].gif";

class FinalizarDiagnosticoPlanMovilidad extends React.PureComponent {

  componentDidUpdate() {
    if (this.props.medidasGeneradas && this.props.estadoProceso !== 3) {
      this.props.dispatch(getListadoPlanesMovilidad(this.props.companyId, this.props.sucursalId, this.props.usuarioRUT));
    }
  }

  componentDidMount = () => {
    scrollElementToTop("finalizar_etapa_diagnostico_plan_movilidad");
  }

  render() {
    return (
      <section id="finalizar_etapa_diagnostico_plan_movilidad">
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
              <div className="col-md-8 p-lg-5 mx-auto my-5 cuadro-1">
                <div className="row col-md-12 PM-tipo-denuncias-select PM-plan-exito">
                  <div className="col-md-12 text-center">
                    <span className="PM-felicita"><strong>¡Felicitaciones!</strong></span>
                  </div>
                  <div className="col-md-12 text-center PM-section-title">Finalizaste la etapa de diagnóstico.</div>
                  <div className="col-md-12 text-center PM-info">
                    <p>Descarga el Informe de Diagnóstico y pasa a la próxima etapa, donde como centro de trabajo deberán definir las acciones a implementar y los plazos de ejecución.</p>
                    {
                      (!this.props.medidasGeneradas) ?
                        <div>
                          <p style={{ fontSize: 30 }}>Las Medidas se están generando, por favor espere...</p>
                          <img src={IMG_LOADING} alt="carga" />
                        </div>
                        :
                        <div>
                          <ul>
                            {this.props.medidasPlanMovilidad.map((medida, k) => (
                              <li key={k}>{medida.descripcion}</li>
                            ))}
                          </ul>
                        </div>
                    }
                  </div>
                </div>
                <div className="row PM-home-item-plan PM-plan-contador-finalizar PM-plan-botones-encuesta">
                  <div className="col-md-12 PM-button">
                    <button
                      className="btn PM-solo-borde PM-dx-button-plan-100"
                      onClick={() => {
                        getDocumentoEstadisticas(this.props.idplanMovilidad);
                        // gtd -> genera informe estadistico
                        dataLayerTag({
                          'event': 'etapa_2_genera_informe',
                          'etapa': '2'
                        });
                      }}
                      disabled={!this.props.medidasGeneradas}
                    >Descargar Informe</button>
                    <button
                      className="btn PM-dx-button-plan PM-dx-button-plan-100"
                      style={{ marginTop: 10 }}
                      onClick={() => {
                        this.props.dispatch(changeEtapas(2));
                      }}
                      disabled={!this.props.medidasGeneradas}
                    >Continuar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  estadoProceso: state.planMovilidad.estadoProceso,
  medidasGeneradas: state.planMovilidad.medidasGeneradas,
  medidasPlanMovilidad: state.planMovilidad.medidasPlanMovilidad,
  sucursalId: state.global.sucursalId,
  companyId: state.global.companyId,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  usuarioRUT: state.global.userData.RUT,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalizarDiagnosticoPlanMovilidad);
